import { getCurrentLocalDate } from "helpers/CurrentDate/getCurrentLocalDate";
import { DEFAULT_ORGANISATION } from "./serviceInitialValues";

export interface QuotationFormValues {
  // Quotation Details
  quotation_id?: string; // For edit mode
  quotation_date: string;
  valid_until: string;
  enquiry_reference_number: string;
  enquiry_product_id: string;
  enquiry_service_id?: string;
  reference_number?: string;
  initiated_by: string;

  // Quotation Status
  quotation_status?: string;
  quotation_stage?: string;

  // Customer Details
  customer_details: any; // Complete customer information for backend
  company: {
    company_id: string;
    company_name: string;
    branch_name?: string;
    vendor_code?: string;
    industry?: string;
    gst_type?: string;
    company_email?: string;
    phone_number?: string;
    gstin?: string;
    billing_address?: any;
    contacts?: any[];
    shipping_addresses?: any[];
  } | null;
  contact_persons: Array<{
    id: string;
    name: string;
    designation?: string;
    phone_country?: string;
    phone_number?: string;
    email?: string;
  }>;

  // Agent Details
  agent_name: string;

  // Assign Members
  members: Array<{
    id: string;
    name: string;
    initials?: string;
  }>;

  // Currency & Exchange
  currency: string;
  currency_symbol?: string;
  exchange_rate: string;

  // EMD Details
  mode_of_emd: string;
  emd_amount: string;

  // Inspection & Installation
  inspection: string;
  inspection_date: string;
  installation: string;
  installation_date: string;

  // Products
  products: Array<{
    id: string;
    sr_no: number;
    product_name: string;
    sku: string;
    hsn_code: string;
    make: string;
    model: string;
    is_serviceable: boolean;
    quantity: number;
    unit: string;
    unit_price: number;
    discount_type: 'percentage' | 'currency';
    discount_value: number; // raw value expected by backend
    calculated_discount_value: number; // frontend-only computed amount
    net_value: number;
    gst_percentage: number;
    gst_value: number;
    total: number;
    shipping_address: {
      shipping_address_id: string;
      address: string;
      city: string;
      state: string;
      country: string;
      pincode: string;
      phone_number: string;
      is_default: boolean;
    } | null;
    rate_in_currency: number;
    gross_value: number;
  }>;

  // Terms & Conditions
  terms_and_conditions: Array<{
    id: string;
    type: string;
    option: string;
    description: string;
  }>;

  // Notes, Tags & Attachments
  notes: string;
  tags: string[];
  attachments: File[];

  // Follow-up
  next_follow_up_date: string;
  follow_up_remarks: string;
  bill_from_address?: any;
}

// Get default date (today) using getCurrentLocalDate helper
const defaultQuotationDate = getCurrentLocalDate();

export const initialQuotationValues: QuotationFormValues = {
  quotation_date: defaultQuotationDate,
  valid_until: "",
  enquiry_reference_number: "",
  enquiry_product_id: "",
  enquiry_service_id: "",
  reference_number: "",
  initiated_by: "",
  customer_details: null,
  company: null,
  contact_persons: [],
  agent_name: "",
  members: [],
  currency: "INR",
  currency_symbol: "₹",
  exchange_rate: "1",
  mode_of_emd: "",
  emd_amount: "",
  inspection: "Not Applicable",
  inspection_date: "",
  installation: "Not Applicable",
  installation_date: "",
  products: [],
  terms_and_conditions: [],
  notes: "",
  tags: [],
  attachments: [],
  next_follow_up_date: "",
  follow_up_remarks: "",
  bill_from_address: DEFAULT_ORGANISATION,
};

